<template>
  <div class="animated fadeIn">
    <b-card v-if="showForm==false">
      <div slot="header">
        Relasi/Prospek (Non Customer)
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>
            Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7" class="pr-5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Prospek/Relasi</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.CustName"></b-form-input>
            <b-input-group-prepend>
              <span class="p-2">Alamat Pengiriman</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.DeliveryAddr"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <span class="p-2">Sales(AE)</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.salesae_name" placeholder="Sales (AE)" @change="tblData.salesae_id=''"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-button class="btn btn-success ml-4 mr-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply Filter
            </b-button>
            <b-button class="btn btn-secondary" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear Filter
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        show-empty
      >
         <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
            <a href="javascript:void(0)" @click.stop="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a
              href="javascript:void(0)"
              class="text-danger"
              @click.stop="deleteConfirm(data.item)"
            >
              <i class="fa fa-trash"></i>
            </a>
          </div>
        </template>

      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
            <b-form-select
              :options="tblData.pageOptions"
              :plain="true"
              v-model="tblData.limit"
              @change="refresh"
              style="width:80px;"
            />
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm==true">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">
            {{$route.meta.label}} - Add/Edit Form
          </div>
          <b-input-group>
            <b-input-group-prepend><label>Nama Relasi</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.CustName" :state="!$v.frmdata.CustName.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Alamat Pengiriman</label></b-input-group-prepend>
            <b-form-textarea v-model="frmdata.DeliveryAddr" :state="!$v.frmdata.DeliveryAddr.$error" rows="2" max-rows="5"></b-form-textarea>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>City</label></b-input-group-prepend>
            <b-form-input v-model="frmdata.City" ></b-form-input>
            <b-input-group-prepend><span class="pl-3 pt-2 pr-1">Phone</span></b-input-group-prepend>
            <b-form-input v-model="frmdata.PhoneNo" ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label >Sales(AE)</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdata.salesae_name" placeholder="Sales (AE)" ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" id="btnKoranCust" @click="lkuKoranSalesShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>

        </b-card>
      </b-col>
    </b-row>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal
      v-model="lkuKoranSalesShow"
      size="lg"
      :hide-footer="true"
      title="List Sales"
      :centered="true"
    >
      <lku-salesae @click="onSelectKoranSales" crudfilter="koran=1"></lku-salesae>
    </b-modal>


  </div>
</template>




<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import noncustomer from "../../apis/koran_noncustomer";
import lkuSalesae from "../lookup/lkuSalesae";

import toastr from "mini-toastr";
toastr.init();

export default {
  components: { Loading, lkuSalesae },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      CustName: { required },
      DeliveryAddr: { required }
    }
  },  
  data() {
    return {
      showDelConfirm: false,
      lkuKoranSalesShow: false,
      showForm: false,
      frmdata: {
        CustName: '',
        DeliveryAddr: ''
      },
      showFilter: false,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      terpilih: { noncust_id: "" },
      customerGroups: [],
      tblData: {
        noncust_group: "",
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        pageOptions: [10, 20, 30, 50, 70, 90, 120],
        sortBy: null,
        sortDesc: false,
        koran: "1"
      },
    tblFields: [
        {
          key: "CustName",
          label: "Nama Non Customer",
          sortable: true
        },
        {
          key: "DeliveryAddr",
          label: "Billing Address"
        },
        {
          key: "City",
          label: "City",
          sortable: true
        },
        {
          key: "PhoneNo",
          label: "Phone",
          thStyle: "width:150px"
        },
        {
          key: "salesae_name",
          label: "Sales (AE)",
          thStyle: "width:150px",
          sortable: true
        },
        {
          key: "createby",
          label: "Input By",
          thStyle: "width:80px",
          sortable: true
        },
        {
          key: "action",
          label: "action",
          thStyle: "width:50px",
          sortable: true
        }
      ],
    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },  

  methods: {
    onSelectKoranSales: function(_selected) {
      this.tblData.salesae_id = _selected.salesae_id;
      this.tblData.salesae_name = _selected.salesae_name;
      this.frmdata.salesae_id = _selected.salesae_id;
      this.frmdata.salesae_name = _selected.salesae_name;
      this.lkuKoranSalesShow = false;
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      try {
        this.Loading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        const list = await noncustomer.list(this.tblData);
        this.Loading = false;
        return list;
      } catch (error) {
        this.Loading = false;
        toastr.error(error.message);
      }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    clearFilter(ctx) {
      this.tblData.Name = "";
      this.tblData.noncust_group = "";
      this.tblData.salesae_codename = "";
      this.refresh();
    },
    add: function() {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.frmdata.koran = 1;
      this.showForm = true;
    },
    edit: async function(data) {
      this.terpilih=data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in data) {
        this.frmdata[key] = data[key];
      }
      this.showForm = true;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          this.isLoading = true;
          await noncustomer.save(this.frmdata);
          this.isLoading = false;
          this.showForm=false;
        } catch (error) {
          this.isLoading = false;
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }   
        }
      }
    },
    closeFrm() {
      this.showForm = false;
    },    
    deleteConfirm(data) {
      this.terpilih=data;
      if (this.terpilih.noncust_id) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Deleted!");
      }
    },
    deleteData: async function() {
      try {
        await noncustomer.remove(this.terpilih);
        this.refresh();
      } catch (error) {
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    rowClicked(record, index) {
      if (this.terpilih.noncust_id == record.noncust_id) {
        this.edit();
      } else {
        if (this.terpilih && this.terpilih._rowVariant) {
          delete this.terpilih._rowVariant;
        }
        this.terpilih = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        const response = await noncustomer.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("/receivable/home");
    }
  }
};
</script>
